import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=3632bd2c&scoped=true"
import script from "./msg.vue?vue&type=script&lang=js"
export * from "./msg.vue?vue&type=script&lang=js"
import style0 from "./msg.vue?vue&type=style&index=0&id=3632bd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632bd2c",
  null
  
)

export default component.exports